import type { ICaseItemDtoV2 } from '@dev-fast/types';

import type { IPossibleItem } from '../types/frontend';

export const possibleItemsAdapter = (caseItem: ICaseItemDtoV2): IPossibleItem[] => {
  return (
    caseItem.lastRevision?.items?.map((i) => ({
      image: i.inventoryItem?.baseItem?.imageProfile || '',
      id: i.id,
      name: i.inventoryItem?.baseItem?.shortName || '',
      type: i.inventoryItem?.baseItem?.skin || '',
      price: i.inventoryItem?.price ?? 0,
    })) || []
  );
};
